import { useState, useEffect } from "react";

/**
 * Custom hook to detect viewport breakpoints
 * @returns object containing boolean flags for different device sizes
 */
export const useBreakpoints = () => {
  const [breakpoints, setBreakpoints] = useState({
    isMobile: window.innerWidth <= 768,
    isTablet: window.innerWidth > 768 && window.innerWidth <= 1024
  });

  /**
   * Effect to handle window resize events
   * Updates breakpoint states when viewport width changes
   * Cleans up event listener on unmount
   */
  useEffect(() => {
    const handleResize = () => {
      setBreakpoints({
        isMobile: window.innerWidth <= 768,
        isTablet: window.innerWidth > 768 && window.innerWidth <= 1024
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoints;
};
